import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchPt = () => {
    return <AdvancedSearch languageCode="pt" />
}

export default AdvancedSearchPt
